function ProblemCards() {
    const cards: ProblemCard[] = [
        {
            title: 'Net Asset Value',
            description: 'Crypto assets are traded on different marketplaces at different prices. With our price finding algorithm, we offer valid, transparent and comprehensible pricing. ',
            icon: 'calculator'
        },
        {
            title: 'Underling Assets',
            description: 'Some tokens have underling assets, such as liquidity tokens. In our tool, we therefore process the data at the lowest asset level and visualize it accordingly.',
            icon: 'shield-alert'
        },
        {
            title: 'Record Transactions',
            description: 'Cashflow strategies increase the complexity and amount of transactions. Thats why we are constantly onboarding new blockchains to provide automated and human readable transaction tracking.',
            icon: 'data-transfer-check'
        },
        {
            title: 'Counterparty Risk',
            description: 'Crypto often means anonymity. This is a problem for professional investors. That is why we offer an overview of trusted and tracked staking validators and provide extended documents to them.',
            icon: 'warning-window'
        },
        {
            title: 'Regulatorical Requirements',
            description: 'The regulatory framework is constantly changing. Through our experts, we get first-hand information and can thus react quickly to implement new required features into our tool. ',
            icon: 'book-stack'
        },
        {
            title: 'Alerts',
            description: 'It is important to be informed what is happening in the portfolio. Via our Notification Center you can define individual signals to be automatically informed about important events. ',
            icon: 'message-alert'
        }
    ]
    return( 
        <div className="max-w-screen-xl box m-auto mb-16 max-xl:p-5">
            <h1 className="text-4xl font-bold text-slate-800 mb-3 max-md:text-3xl">
            Professional investors need new types of tools <br/> that are developed with a holistic view.
            </h1>
            <p className="font-medium text-slate-400 mb-10">
                High quality, privacy and security is expensive! Stop using tools that are made for mainstream and <br/> start using tools that meet your professional requirements to reduce uncertainty, risk and effort.
            </p>
            <br/>
            <br/>
            <div className="flex justify-items-stretch flex-wrap">
                {
                    cards.map((card, i) => (
                        <div className="flex flex-col items-center w-full sm:w-6/12 md:w-4/12 mb-10" key={"problemCard-" + i}>
                            <i className={"iconoir-" + card.icon + " text-3xl text-blue-600 mb-2"}></i>
                            <h2 className="font-semibold text-slate-800">
                                {card.title}
                            </h2>
                            <p className="text-slate-400 text-justif py-4 md:w-10/12 lg:w-full">
                                {card.description}
                            </p>
                        </div>
                    ))
                }
            </div> 
        </div>
    )
}

export default ProblemCards;

interface ProblemCard {
    title: string;
    description: string;
    icon: string;
}